import { mount } from 'svelte';
import '@u-elements/u-tabs';
import App from './App.svelte';
import { environment, nrkContext } from './utils/context';
import { initSentry } from './utils/sentry';
import { initializeVersionCheck } from './utils/versionCheck';

initSentry(environment, nrkContext.nrkSession);
initializeVersionCheck();

const app = mount(App, {
  target: document.getElementById('app')!,
});

export default app;
